import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { __Rutas } from "./../../Core/environment";
import HomePage from "./../../Pages/Home/Home.page";
import CatalogoPage from "./../../Pages/Catalogo/Catalogo.page";
import NotFoundPage from "./../../Pages/NotFound/NotFound.page";
import LoginPage from "./../../Pages/Login/Login.page";
import RegistroPage from "./../../Pages/Registro/Registro.page";

const PublicRoute = () => {
  return (
    <Switch>
      <Route exact path={__Rutas.Home} component={HomePage} />
      <Route exact path={__Rutas.Catalogo} component={CatalogoPage} />
      <Route exact path={__Rutas.Login} component={LoginPage} />
      <Route exact path={__Rutas.Registro} component={RegistroPage} />
      <Redirect from={__Rutas.Carrito} to={__Rutas.Home} />
      <Redirect from={__Rutas.Historial} to={__Rutas.Home} />
      <Route exact strict component={NotFoundPage} />
    </Switch>
  );
};

export default PublicRoute;
